module.exports = __webpack_public_path__ + "img/truss_bridges.10ec0254.jpg";